{
  "Untitled event": "Event ohne Titel",
  "Under a minute": "Unter einer Minute",
  "{minutes} min": "{minutes} Min.",
  "{hours} h {minutes} min": "{hours} Std. {minutes} Min.",
  "{hours} h": "{hours} Std.",
  "Under 1 MB": "Unter 1 MB",
  "{count} part": {
    "one": "{count} Teil",
    "other": "{count} Teile"
  },
  "{count} recording": {
    "one": "{count} Aufzeichnung",
    "other": "{count} Aufzeichnungen"
  },
  "data file|Event details": "Eventdetails",
  "Every event's title, date, place, link and settings": "Titel, Datum, Ort, Link und Einstellungen jedes Events",
  "Guests and registrations": "Gäste und Registrierungen",
  "Names, emails, how each guest joined and what they watched": "Namen, E-Mail-Adressen, wie die Gäste dabei waren und was sie angesehen haben",
  "Guestbook messages": "Nachrichten im Gästebuch",
  "Every message with its event, name and time": "Jede Nachricht mit Event, Name und Uhrzeit",
  "Viewer counts": "Zuschauerzahlen",
  "Live and replay viewers for each recording": "Live-Zuschauer und Zuschauer der Aufzeichnung für jedes Video",
  "Sales and donations": "Verkäufe und Spenden",
  "Tickets, paid downloads and donations, with amounts and dates": "Tickets, bezahlte Downloads und Spenden mit Betrag und Datum",
  "This recording belongs to another account.": "Diese Aufzeichnung gehört zu einem anderen Konto.",
  "We couldn't find this recording. It may have been deleted.": "Wir konnten diese Aufzeichnung nicht finden. Vielleicht wurde sie gelöscht.",
  "Downloads are temporarily unavailable. Please try again in a few minutes.": "Downloads sind vorübergehend nicht verfügbar. Bitte versuche es in ein paar Minuten erneut.",
  "Could not reach EventLive. Check your internet connection and try again.": "EventLive ist nicht erreichbar. Prüfe deine Internetverbindung und versuche es erneut.",
  "Ready to download": "Bereit zum Herunterladen",
  "{count} recording is being prepared": {
    "one": "{count} Aufzeichnung wird vorbereitet",
    "other": "{count} Aufzeichnungen werden vorbereitet"
  },
  "Download this one when one of them is ready.": "Lade diese herunter, sobald eine davon fertig ist.",
  "Could not load your recordings.": "Deine Aufzeichnungen konnten nicht geladen werden.",
  "Couldn't download the file": "Die Datei konnte nicht heruntergeladen werden",
  "Still preparing. Long recordings take a while; you can leave this page and come back.": "Wird noch vorbereitet. Lange Aufzeichnungen brauchen etwas Zeit – du kannst diese Seite verlassen und später zurückkommen.",
  "Joining {parts} parts into one MP4. This usually takes a few minutes.": "{parts} Teile werden zu einer MP4-Datei zusammengefügt. Das dauert meist ein paar Minuten.",
  "Preparing the MP4. This usually takes a few minutes.": "Die MP4-Datei wird vorbereitet. Das dauert meist ein paar Minuten.",
  "This is taking much longer than usual. Try again, or contact support.": "Das dauert viel länger als üblich. Versuche es erneut oder kontaktiere den Support.",
  "Couldn't prepare the download. Try again.": "Der Download konnte nicht vorbereitet werden. Versuche es erneut.",
  "In the Secure Archive, so it can't be downloaded. Restore it to download it again, or delete it.": "Im sicheren Archiv, daher nicht herunterladbar. Stelle sie wieder her, um sie erneut herunterzuladen, oder lösche sie.",
  "In the Secure Archive, so it can't be downloaded. You can delete it.": "Im sicheren Archiv, daher nicht herunterladbar. Du kannst sie löschen.",
  "Restore {title}": "{title} wiederherstellen",
  "Delete {title}": "{title} löschen",
  "Download": "Herunterladen",
  "Preparing…": "Wird vorbereitet…",
  "Preparing {title}": "{title} wird vorbereitet",
  "Try again: {title}": "Erneut versuchen: {title}",
  "Download {title}": "{title} herunterladen",
  "Guestbook PDF · {count} message": {
    "one": "Gästebuch-PDF · {count} Nachricht",
    "other": "Gästebuch-PDF · {count} Nachrichten"
  },
  "Download the guestbook of {title} as a PDF": "Gästebuch von {title} als PDF herunterladen",
  "Download {title} (CSV)": "{title} herunterladen (CSV)",
  "Deleted": "Gelöscht",
  "Couldn't delete it": "Konnte nicht gelöscht werden",
  "Delete “{title}”?": "„{title}“ löschen?",
  "The event, its recording, guest list and guestbook are deleted for good. This can't be undone.": "Das Event, seine Aufzeichnung, die Gästeliste und das Gästebuch werden endgültig gelöscht. Das kann nicht rückgängig gemacht werden.",
  "Delete event": "Event löschen",
  "Loading your recordings…": "Deine Aufzeichnungen werden geladen…",
  "one MP4 file each": "je eine MP4-Datei",
  "loading more…": "weitere werden geladen…",
  "Download everything": "Alles herunterladen",
  "Your recordings are yours. Download any of them, any time, free.": "Deine Aufzeichnungen gehören dir. Lade sie jederzeit kostenlos herunter.",
  "Give a family or a couple their video, or keep your own archive.": "Gib Familien oder Paaren ihr Video oder leg dein eigenes Archiv an.",
  "Download everything is for business accounts. To download a video, open its event and choose Download & View Stats.": "„Alles herunterladen“ gibt es für Geschäftskonten. Um ein Video herunterzuladen, öffne das zugehörige Event und wähle „Herunterladen & Statistiken ansehen“.",
  "Recordings": "Aufzeichnungen",
  "Couldn't load your recordings": "Deine Aufzeichnungen konnten nicht geladen werden",
  "No recordings yet": "Noch keine Aufzeichnungen",
  "When you stream an event or upload a video, it shows up here, ready to download.": "Wenn du ein Event streamst oder ein Video hochlädst, erscheint es hier – bereit zum Herunterladen.",
  "Search for a recording": "Nach einer Aufzeichnung suchen",
  "Search recordings by title, place or date": "Aufzeichnungen nach Titel, Ort oder Datum durchsuchen",
  "Clear search": "Suche löschen",
  "No recordings match “{query}”.": "Keine Aufzeichnungen passen zu „{query}“.",
  "Show {count} more": "{count} weitere anzeigen",
  "{count} recording found.": {
    "one": "{count} Aufzeichnung gefunden.",
    "other": "{count} Aufzeichnungen gefunden."
  },
  "Each MP4 joins every live session and upload in order, in the best quality we keep.": "Jede MP4-Datei fügt alle Live-Sessions und Uploads der Reihe nach zusammen – in der besten Qualität, die wir speichern.",
  "Long recordings are big files, so use a fast connection.": "Lange Aufzeichnungen sind große Dateien, nutze also eine schnelle Verbindung.",
  "It opens in your browser to save. Long recordings are big files: a computer on Wi-Fi is quickest.": "Die Datei öffnet sich zum Speichern in deinem Browser. Lange Aufzeichnungen sind große Dateien: Am schnellsten geht es mit einem Computer im WLAN.",
  "Your data": "Deine Daten",
  "Spreadsheets for Excel, Numbers or Google Sheets, covering every event in your account": "Tabellen für Excel, Numbers oder Google Sheets mit allen Events in deinem Konto",
  "One page with your events that anyone with the link can watch, and your ticketed events, newest first.": "Eine Seite mit deinen Events, die alle mit dem Link ansehen können, und deinen Events mit Tickets – die neuesten zuerst.",
  "Your Video Wall link": "Link zu deiner Videowand",
  "Video Wall link": "Link zur Videowand",
  "Copy Video Wall link": "Link zur Videowand kopieren",
  "Open Video Wall": "Videowand öffnen",
  "Embed on your website": "Embed auf deiner Website",
  "Paste the code into your website's HTML or embed block.": "Füge den Code in das HTML deiner Website oder in einen Embed-Block ein.",
  "Code type": "Code-Typ",
  "Script (recommended)": "Skript (empfohlen)",
  "The wall grows to fit all your events instead of scrolling inside a box.": "Die Wand wird so groß, dass alle deine Events hineinpassen, statt in einem Kasten zu scrollen.",
  "Simple iframe (no script)": "Einfaches iframe (ohne Skript)",
  "For site builders that remove scripts. The wall scrolls inside the space your page gives it.": "Für Website-Baukästen, die Skripte entfernen. Die Wand scrollt innerhalb des Platzes, den deine Seite ihr gibt.",
  "Copy embed code": "Embed-Code kopieren",
  "Embed code copied": "Embed-Code kopiert",
  "Paste it into your website's HTML.": "Füge ihn in das HTML deiner Website ein."
}
